import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const TicketType = () => {
  return (
    <SettingsMetaData propertyName={"Ticket_Type"} viewPropertyName={"Ticket Type"} />
  );
};
export default TicketType;